import { AreaDefinition, GeometryApi } from '@cibo/core'

export const geometryForAreaDef = async (areaDef: AreaDefinition) => {
  switch (areaDef.type) {
    case 'feature':
      return areaDef.feature?.geometry

    case 'fips':
      if (areaDef.fips) return GeometryApi.getGeometry(areaDef.fips)
      break

    case 'circle':
      console.warn('BoundaryThumbnail: "circle" boundary area not supported', areaDef)
      return
  }
}
